import React from "react";
import PpcFarmMailingLedgerClient from "../../components/ppc-farm/PpcFarmMailingLedgerClient";

const PpcFarmMailingLedgerPage: React.FC = () => {
  return <PpcFarmMailingLedgerClient />;
};

export default PpcFarmMailingLedgerPage;
